import OasisSettings from '@/modules/integrations/types/oasis/OasisSettings'

export default Object.freeze({
  type: 'oasis',
  title: 'Integrations_Oasis',
  category: 'Integrations_Oasis_Category',
  description: 'Integrations_Oasis_Description',
  image: require('@/img/integrations/oasis.png'),
  requiresAdmin: false,
  components: {
    settings: OasisSettings,
    overview: null
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/oasis-national-exclusion-database'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/oasis/index.js